<div class="filters-container">
  <div class="select-filters-container">
    <ng-select
      class="select-styles"
      [clearable]="false"
      [(ngModel)]="selectedFunction"
      (change)="selectionChanged()"
      [items]="functionOptions$ | async"
    ></ng-select>
    <ng-select
      class="select-styles"
      [disabled]="isDisabled"
      [clearable]="false"
      [(ngModel)]="selectedDepartment"
      (change)="selectionChanged()"
      [items]="departmentOptions$ | async"
    ></ng-select>
    <ng-select
      *ngIf="pipelineJobStatus"
      class="select-styles"
      [clearable]="false"
      [(ngModel)]="selectedJobStatus"
      (change)="jobStatusFilterChanged()"
      [items]="statuses"
    ></ng-select>
  </div>
  <ng-select
    *ngIf="jobStatusFilter"
    class="select-styles"
    [clearable]="false"
    [(ngModel)]="selectedJobStatus"
    (change)="jobStatusFilterChanged()"
    [items]="statuses"
  ></ng-select>
  <div
    *ngIf="datePickerFilter"
    class="date-picker-filter-container"
  >

    <div
      class="d-flex align-items-center datepicker-form-field"
      [matDatepicker]="picker"
    >
      <div
        class="d-flex align-items-center"
        (click)="picker.open()"
      >
        <mat-datepicker-toggle
          matPrefix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        <mat-date-range-input
          [formGroup]="range"
          [rangePicker]="picker"
          [min]="minDate"
        >
          <input
            matStartDate
            (dateChange)="datePickerStatusChange()"
            formControlName="start"
            placeholder="Start date"
          >
          <input
            matEndDate
            (dateChange)="datePickerStatusChange()"
            formControlName="end"
            placeholder="End date"
          >
        </mat-date-range-input>
      </div>
      <mat-datepicker-toggle
        *ngIf="isDatePickerFilled()"
        class="clear-date-picker"
        matSuffix
        (click)="clearDatePicker()"
      >
        <mat-icon
          class="close-icon"
          matDatepickerToggleIcon
        >close</mat-icon>
      </mat-datepicker-toggle>
    </div>

  </div>
  <ng-content></ng-content>
</div>
